import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { injectedWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets'
import { mainnet } from 'wagmi/chains'

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '28284b025482b2086b67683e76511d31'

// Use only injected + WalletConnect to avoid @metamask/sdk (openapi-fetch) errors.
// Injected works with MetaMask extension, Brave, etc. without loading the SDK.
export const config = getDefaultConfig({
  appName: 'Jumper Exchange',
  projectId: projectId || '28284b025482b2086b67683e76511d31',
  chains: [mainnet],
  ssr: false,
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [injectedWallet, walletConnectWallet],
    },
  ],
})
